 import React from 'react';
import { motion } from 'framer-motion';

const colors = {
  secondary: '#9f7aea',
  accent: '#f687b3',
  text: '#e2e8f0',
};

const Education = ({ degree, institution, year }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="mb-4"
    >
      <h3 className="text-lg font-semibold" style={{ color: colors.secondary }}>{degree}</h3>
      <p style={{ color: colors.text }}>{institution}</p>
      <p className="text-sm" style={{ color: colors.accent }}>{year}</p>
    </motion.div>
  );
};

export default Education;
